// Reusable validation function with conditional logic
export const validateFields = (fields, rules) => {
  let errors = {};

  // Loop through the validation rules and validate each field conditionally
  Object.keys(rules).forEach((field) => {
    const value = fields[field];
    const rule = rules[field];

    if (rule.isConditionMet) {
      // Ensure value is a string before using trim()
      const valueToCheck = typeof value === "string" ? value.trim() : value;

      // Required field validation
      if (rule.required && !valueToCheck) {
        errors[field] = rule.errorMessage;
      }

      // Pattern validation
      if (rule.pattern && !rule.pattern.test(valueToCheck)) {
        errors[field] = rule.patternErrorMessage || rule.errorMessage;
      }

      // Min length validation
      if (rule.minLength && valueToCheck.length < rule.minLength) {
        errors[field] = rule.errorMessage;
      }
    }
  });

  return errors;
};
